<template>
    <div class="News">
        <RouteHeadAndCrumbs
            :backgroundImg="backgroundImg"
            :breadcrumbsInfo="breadcrumbsInfo"
        />
        <div class="news-main-container">
            <el-row :gutter="26">
                <template v-for="item in newsList">
                    <el-col :key="item.id" :span="6">
                        <router-link :to="`/news/detail/${item.id}`">
                            <div class="one-news-info-container">
                                <div class="news-date-container">
                                    <span class="date-text">{{
                                        getDateStr(item)
                                    }}</span>
                                    <span class="year-text">{{
                                        getYearStr(item)
                                    }}</span>
                                </div>
                                <div class="one-news-img-container">
                                    <img :src="item.imgUrl" alt="" />
                                </div>
                                <p class="one-new-title-text">
                                    {{ item.title }}
                                </p>
                                <p class="one-new-content-text">
                                    {{ item.description }}
                                </p>
                                <div class="show-detail-btn-container">
                                    <router-link
                                        :to="`/news/detail/${item.id}`"
                                    >
                                        <el-link
                                            class="show-detail-btn"
                                            :underline="false"
                                        >
                                            <span>查看详情</span>
                                            <i class="el-icon-right"></i>
                                        </el-link>
                                    </router-link>
                                </div>
                            </div>
                        </router-link>
                    </el-col>
                </template>
                
            </el-row>
        </div>
        <div class="show-more-news-btn-container">
            <el-button
                v-if="
                    this.pagination.pageNum * this.pagination.pageSize <
                    this.total
                "
                class="show-more-news-btn"
                @click="showMore"
                plain
                >加载更多</el-button
            >
        </div>
    </div>
</template>

<script>
import headImg from "../assets/images/news.png";

import { ROUTEINFO } from "../utils/constant";

import { GETNEWSLIST } from "../utils/uriList";

export default {
    mounted() {
        this.getNewsList();
    },
    data() {
        return {
            backgroundImg: headImg,
            breadcrumbsInfo: [
                {
                    routeName: ROUTEINFO.home.name,
                    routeLabel: "首页",
                    routeTo: {
                        path: ROUTEINFO.home.path,
                    },
                },
                {
                    routeName: ROUTEINFO.news.name,
                    routeLabel: "新闻资讯",
                },
            ],
            newsList: [],
            pagination: {
                pageSize: 8,
                pageNum: 1,
                approvalStatus:0,
            },
            total: 0,
        };
    },
    methods: {
        async getNewsList() {
            const response = await this.$http.get(GETNEWSLIST, {
                params: this.pagination,
                
            });
            if (response.data.code === 0) {
                this.newsList = response.data.data.content;
                this.total = response.data.data.totalSize;
            }
        },
        getDateStr(item) {
            const time = item.time;
            const splitList = `${time}`.split("-");
            return `${splitList[1]}/${splitList[2]}`;
        },
        getYearStr(item) {
            const time = item.time;
            const splitList = `${time}`.split("-");
            return `${splitList[0]}`;
        },
        showMore() {
            if (
                this.pagination.pageNum * this.pagination.pageSize <
                this.total
            ) {
                const pagination = { ...this.pagination };
                pagination.pageNum += 1;
                this.pagination = pagination;
                this.getNewsList();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/views/News.scss";
</style>
